"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const houston_styles_1 = require("@eduzz/houston-styles");
const styles_1 = tslib_1.__importDefault(require("./styles"));
const Box = props => {
    const { children, className, paper } = props, rest = tslib_1.__rest(props, ["children", "className", "paper"]);
    const classes = (0, styles_1.default)(props);
    return ((0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({}, rest, { className: (0, houston_styles_1.cx)(className, classes.box, paper && classes.paper) }, { children: children })));
};
exports.default = React.memo(Box);
